import React from "react";

class ErrorBoundary extends React.Component {
    constructor(props:any) {
      super(props);
      this.state = { hasError: false };
    }
  
    static getDerivedStateFromError(error:any) {
      // Update state so the next render will show the fallback UI.
      return { hasError: true,error };
    }
  
    componentDidCatch(error:any, info:any) {
      // Example "componentStack":
      //   in ComponentThatThrows (created by App)
      //   in ErrorBoundary (created by App)
      //   in div (created by App)
      //   in App
    //   logErrorToMyService(error, info.componentStack);
    }
  
    render() {
      const props:any = this.props;
      const state:any = this.state;
      if (state.hasError) {
        // You can render any custom fallback UI
        return JSON.stringify(state.error);
      }
  
      return props.children;
    }
  }

  export default ErrorBoundary